import { Check, Languages } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { LOCALES, useI18n, type Locale } from '@/i18n'

/**
 * Language picker. The list comes from LOCALES, so adding a dictionary in
 * src/i18n/ is the only step needed to offer another language — this component
 * never needs editing.
 *
 * Each option is written in its OWN language ("Tiếng Việt", not "Vietnamese"):
 * someone looking for their language cannot read the name of it in a language
 * they do not have yet.
 */
export function LanguageToggle() {
  const { locale, setLocale, t } = useI18n()
  const entries = Object.entries(LOCALES) as [Locale, string][]

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={t('language.label')} title={t('language.label')}>
          <Languages className="size-4" strokeWidth={1.75} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-40">
        <DropdownMenuLabel>{t('language.label')}</DropdownMenuLabel>
        {entries.map(([code, name]) => (
          <DropdownMenuItem key={code} onSelect={() => setLocale(code)}>
            <span data-upbo-src="src/components/LanguageToggle.tsx:36" className="flex-1">{name}</span>
            {locale === code && <Check className="size-3.5" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
